import Vue from 'vue'
import VueRouter from 'vue-router'
import {store} from '../store/index';
import { sync, } from 'vuex-router-sync';

import VueSimpleSVG from 'vue-simple-svg'
Vue.use(VueSimpleSVG);

import {routes} from './routes'

Vue.use(VueRouter);

export const router = new VueRouter({
    mode: 'history',
    fallback: true, //router should fallback to hash (#) mode when the browser does not support history.pushState
    linkExactActiveClass: "active", // active class for *exact* links.
    routes
});

router.beforeEach((to, from, next) =>{
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (store.getters.getToken === null) {
            store.dispatch('logout');
            next('login');
        }
    }

    next();
});

sync(store, router);

export default router
